import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
// import GoogleDrive from 'uppy/lib/plugins/GoogleDrive';
// import Dropbox from 'uppy/lib/plugins/Dropbox';
// import Instagram from 'uppy/lib/plugins/Instagram';
// import Webcam from 'uppy/lib/plugins/Webcam';
import Tus from '@uppy/tus';
import AwsS3 from '@uppy/aws-s3';
import FileInput from '@uppy/file-input'

import agent from '../../agent'

export default function uppyInit(options, onSuccess) {
  const uppy = Uppy({
    // debug: true,
    autoProceed: options.autoProceed,
    restrictions: options.restrictions || ''
  });
  // console.log('>>>', options)

  uppy.use(Dashboard, {
    // trigger: '.UppyModalOpenerBtn',
    inline: options.inline,
    target: options.target,
    trigger: '#pubregMediaUploadButton',
    replaceTargetContent: true,
    showProgressDetails: true,
    note: options.restrictions || 'Images and video only, 2–3 files, up to 5 MB',
    proudlyDisplayPoweredByUppy: options.proudlyDisplayPoweredByUppy,
    height: 300,
    theme: 'dark',
    width: '100%',
    
    metaFields: options.metaFields,
    locale: {
      strings: {
        browse: 'BROWSE & SELECT',
        dropPaste: 'DRAG YOUR FILES HERE INTO THIS BOX OR USE THE SELECT FILES BUTTON BELOW TO %{browse} YOUR OWN MEDIA'
      }
    }
  });
  
  uppy.use(AwsS3, {
    getUploadParameters(file){
      return agent.Project.requestSignedURL(
        { filename: file.name, 
          content_type: file.type, 
          audition_ids: options.auditions_ids,
          project_id: options.project_id,
          file_size: file.size}).then((res) => {
            return { method: 'PUT', url: res.presigned_url, fields: {}, headers: { 'Content-Type': file.type } }
          })
    }
  });

  uppy.use(FileInput, {
    target: '#pubreg-media-upload-btn',
    pretty: true,
    locale: {
      strings: {
        chooseFiles: 'SELECT FILES TO UPLOAD'
      }
    }
  });


  // uppy.use(XHRUpload, options.xhrUpload)

  uppy.run();

  return uppy
}



// WEBPACK FOOTER //
// ./src/components/uielements/uppy.js